import MdGuideDialog from './MdGuideDialog';

export default MdGuideDialog;
